import React from 'react'
import { connect } from 'react-redux'
import * as BP from '@blueprintjs/core'
import { getAction } from 'src/store/modules/runbooks/actions'
import { getActiveRunbook } from 'src/store/modules/runbooks'
import {
    toggleControl,
    singleEditAction,
} from 'src/store/modules/ui/runbook/controls'

const getHostname = (item) =>
    item.name === item.ci ? 'No hostname' : item.name.replace(item.ci, '')
const getListForViewMode = (viewMode) => (item) => {
    switch (viewMode) {
        case 'cis':
            return item.ci
        case 'hostnames':
            return getHostname(item)
        default:
            return `${item.ci} - ${getHostname(item)}`
    }
}

const filterCis = (cis) => {
    return cis.filter((ci) => {
        const { filteredByUser, filteredByAction } = ci;
        return !filteredByUser && !filteredByAction;
    })
}

class UnderlyingCiAlert extends React.Component {
    state = {
        viewMode: 'cis',
    }
    handleViewModeChange = (value) => () => {
        this.setState({
            viewMode: value,
        })
    }
    getFormattedCis() {
        const { viewMode } = this.state
        const filteredCis = filterCis(this.props.cis)
        return filteredCis.map(getListForViewMode(viewMode))
    }
    handleAlertClose = (confirmed) => {
        // confirmed means OK was clicked, otherwise we copy all
        if (confirmed) {
            this.props.singleEditAction(null)
            this.props.toggleControl('isShowingCIs')
        } else {
            navigator.clipboard
                .writeText(this.getFormattedCis().join('\n'))
                .then(
                    () => {
                        console.log('Underlying CIs copied')
                    },
                    (err) => {
                        console.error('Could not copy text', err)
                    }
                )
        }
    }
    render() {
        const { viewMode } = this.state
        const filteredCis = filterCis(this.props.cis)
        const hasFilteredCis = filteredCis.length > 0

        return (
            <BP.Alert
                className="underlying-cis"
                style={{ maxWidth: 1000, width: '100%' }}
                cancelButtonText={hasFilteredCis && 'Copy ALL'}
                onClose={this.handleAlertClose}
                isOpen={this.props.showingCis}
            >
                <div style={{ width: '100%' }}>
                    <BP.ButtonGroup>
                        <BP.Button
                            onClick={this.handleViewModeChange('cis')}
                            active={viewMode === 'cis'}
                            text="CIs"
                        />
                        <BP.Button
                            onClick={this.handleViewModeChange('hostnames')}
                            active={viewMode === 'hostnames'}
                            text="Hostnames"
                        />
                        <BP.Button
                            onClick={this.handleViewModeChange('both')}
                            active={viewMode === 'both'}
                            text="Both"
                        />
                    </BP.ButtonGroup>
                </div>
                {hasFilteredCis ? (
                    this.getFormattedCis().join(' | ')
                ) : (
                    <p>No underlying CIs</p>
                )}
            </BP.Alert>
        )
    }
}

const mapStateToProps = (state) => {
    const runbook = getActiveRunbook(state)
    const action = getAction(
        state,
        runbook.id,
        state.ui.runbook.controls.singleOpenAction
    )
    const cis = []
    const parseCis = (a) => {
        const act = getAction(state, runbook.id, a)
        if (act.device && act.device !== action.device) {
            cis.push({
                name: act.name,
                ci: act.device,
                filteredByUser: act.filteredByUser,
                filteredByAction: act.filteredByAction,
            })
        }
        for (let child of act.treeChildren) {
            parseCis(child)
        }
    }
    if (action) {
        parseCis(action.uid)
    }
    return {
        runbook,
        action,
        cis: cis.filter((value, index, self) => self.indexOf(value) === index),
        showingCis: state.ui.runbook.controls.isShowingCIs,
    }
}

export default connect(mapStateToProps, {
    toggleControl,
    singleEditAction,
})(UnderlyingCiAlert)
